import React from 'react';
import { Button } from './Button';
import { CountdownTimer } from './CountdownTimer';
import { ShieldCheck, Lock, Zap, Globe2, CheckCircle2, Mail } from 'lucide-react';
interface PurchaseSectionProps {
  id?: string;
}
const kitIncludes = ['6 tomos de educación financiera para todo el año', 'BONO: Plantilla de Planificación Anual Completa', 'BONO: Guía de Gamificación — 5 Dinámicas de Grupo', 'BONO: Banco de Evaluaciones y Rúbricas', 'BONO: Manual de Respuestas para Preguntas Difíciles', 'Entrega inmediata por correo electrónico (PDF)', 'Acceso de por vida — sin vencimiento', 'Garantía de satisfacción de 7 días', 'Pago seguro en tu moneda local'];
export function PurchaseSection({
  id
}: PurchaseSectionProps) {
  return <section id={id} className="scroll-mt-10" data-id="element-174">
      {/* Red urgency countdown strip */}
      <div className="bg-red-950/50 py-4 px-4 text-center border-y border-red-700/40" data-id="element-175">
        <p className="text-red-300 font-black text-sm md:text-base tracking-widest mb-2 animate-pulse uppercase" data-id="element-176">
          ⏰ El precio de lanzamiento termina en:
        </p>
        <CountdownTimer className="!text-red-100 [&_div]:!border-red-700/40 [&_div]:!bg-red-950/70 [&_span]:!text-red-400/70 !text-2xl md:!text-4xl mb-2" data-id="element-177" />
        <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 text-[10px] md:text-xs font-black text-red-200 uppercase tracking-wider mt-2" data-id="element-178">
          <span data-id="element-179">🔥 Últimas unidades</span>
          <span className="text-red-500/40" data-id="element-180">·</span>
          <span data-id="element-181">📢 Oferta Lanzamiento</span>
          <span className="text-red-500/40" data-id="element-182">·</span>
          <span data-id="element-183">📈 Precio sube al terminar</span>
        </div>
        <div className="max-w-md mx-auto mt-3" data-id="element-184">
          <div className="w-full bg-red-950/80 rounded-full h-2 overflow-hidden border border-red-700/30" data-id="element-185">
            <div className="bg-red-400 h-2 rounded-full w-[72%]" data-id="element-186"></div>
          </div>
          <p className="text-[9px] md:text-[10px] text-red-300/80 font-bold mt-1 text-center uppercase tracking-widest" data-id="element-187">
            72% de cupos ocupados
          </p>
        </div>
      </div>

      {/* Pricing section */}
      <div className="py-6 md:py-8 px-4 bg-brand-cardAlt" data-id="element-188">
        <div className="max-w-2xl mx-auto" data-id="element-189">
          <div className="text-center mb-5" data-id="element-190">
            <h2 className="text-xl md:text-3xl font-black text-white tracking-tight leading-none uppercase" data-id="element-191">
              Elegí tu Kit
            </h2>
          </div>

          <div className="bg-brand-card rounded-xl border-4 border-brand-accent p-5 md:p-7 flex flex-col relative shadow-[0_0_40px_rgba(34,197,94,0.3)]" data-id="element-192">
            <div className="absolute top-0 right-4 transform -translate-y-1/2 bg-yellow-400 text-black font-black px-4 py-1 rounded-full text-[10px] md:text-xs tracking-widest shadow-lg whitespace-nowrap uppercase" data-id="element-193">
              ⭐ Recomendado
            </div>

            <h3 className="text-base md:text-xl font-black text-white mb-1 leading-tight uppercase" data-id="element-194">
              📦 KIT COMPLETO EDUCACIÓN FINANCIERA LISTA
            </h3>
            <p className="text-brand-accent font-bold text-xs md:text-sm mb-4" data-id="element-195">
              6 Tomos + 4 Bonos + Acceso inmediato
            </p>

            <div className="flex items-baseline gap-3 mb-5 bg-brand-dark/50 px-4 py-3 rounded-lg border border-white/5" data-id="element-196">
              <span className="text-lg md:text-xl text-gray-500 line-through font-black" data-id="element-197">
                USD 45
              </span>
              <span className="text-4xl md:text-5xl font-black text-brand-accent neon-glow" data-id="element-198">
                USD 19,90
              </span>
            </div>

            {/* Local currency callout — highlighted */}
            <div className="bg-gradient-to-br from-emerald-950/80 to-brand-dark border-2 border-brand-accent/60 rounded-lg p-4 mb-5 shadow-[0_0_20px_rgba(34,197,94,0.2)]" data-id="element-199">
              <div className="flex items-start gap-3" data-id="element-200">
                <div className="bg-brand-accent text-brand-dark rounded-full p-2 shrink-0 shadow-[0_0_15px_rgba(34,197,94,0.5)]" data-id="element-201">
                  <Globe2 className="w-4 h-4 md:w-5 md:h-5" data-id="element-202" />
                </div>
                <div className="flex-grow text-left" data-id="element-203">
                  <p className="text-xs md:text-sm font-black text-brand-accent uppercase tracking-wider mb-1" data-id="element-204">
                    ✅ Pagás en tu moneda local
                  </p>
                  <p className="text-xs md:text-sm text-white font-bold leading-relaxed" data-id="element-205">
                    El precio está expresado en dólares estadounidenses (USD).
                    Al momento del pago{' '}
                    <span className="text-brand-accent" data-id="element-206">
                      se convierte automáticamente
                    </span>{' '}
                    a la moneda de tu país al tipo de cambio del momento: pesos,
                    soles, pesos colombianos, guaraníes, bolívares o cualquier
                    otra moneda local.
                  </p>
                </div>
              </div>
            </div>

            <Button href="https://a3dm10-h0.myshopify.com/cart/44614109200519:1" className="py-4 md:py-5 text-base md:text-xl shadow-[0_0_30px_rgba(34,197,94,0.6)] w-full" pulse={true} data-id="element-207">
              👉 QUIERO MI KIT COMPLETO →
            </Button>

            <p className="text-center text-[10px] md:text-xs text-gray-400 font-black uppercase tracking-widest mt-3 flex items-center justify-center gap-2" data-id="element-208">
              <Lock className="w-3 h-3 text-brand-accent" data-id="element-209" />
              PAGO SEGURO
              <span className="text-gray-600" data-id="element-210">·</span>
              <Mail className="w-3 h-3 text-brand-accent" data-id="element-211" />
              ACCESO INMEDIATO EN TU CORREO
            </p>
          </div>

          {/* Kit Includes Checklist */}
          <div className="bg-brand-card rounded-lg border-2 border-brand-accent/40 p-5 md:p-6 mt-6 shadow-[0_0_20px_rgba(34,197,94,0.15)]" data-id="element-212">
            <h4 className="text-sm md:text-base font-black text-white uppercase tracking-tight mb-4 text-center" data-id="element-213">
              👑 KIT COMPLETO INCLUYE:
            </h4>
            <div className="space-y-2.5" data-id="element-214">
              {kitIncludes.map((item, i) => <div key={i} className="flex items-start" data-id="element-215">
                  <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-brand-accent mr-2.5 shrink-0 mt-0.5" data-id="element-216" />
                  <span className="text-xs md:text-sm text-gray-200 font-bold leading-relaxed" data-id="element-217">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-4 md:gap-6 text-xs md:text-sm text-gray-300 font-black uppercase tracking-wide mt-6" data-id="element-218">
            <div className="flex items-center" data-id="element-219">
              <Lock className="w-4 h-4 mr-1.5 text-brand-accent" data-id="element-220" />
              <span data-id="element-221">Pago seguro</span>
            </div>
            <div className="flex items-center" data-id="element-222">
              <Zap className="w-4 h-4 mr-1.5 text-brand-accent" data-id="element-223" />
              <span data-id="element-224">Acceso en 5 min</span>
            </div>
            <div className="flex items-center" data-id="element-225">
              <ShieldCheck className="w-4 h-4 mr-1.5 text-brand-accent" data-id="element-226" />
              <span data-id="element-227">Garantía 7 días</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}